import React, { useEffect } from 'react';
import styles from './Projects.module.css';
import Title from '../helper/Title';
import { project } from '../data';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import AOS from 'aos';
import 'aos/dist/aos.css';




export default function Projects() {

// AOS animasyon eklentisi
  useEffect(() => {
    
    AOS.init({
      offset:300,
      duration: 1000, 
      easing: 'ease', 
      once: false
    });
  }, []);

  return (
    <section className={styles.section} id="projects">
      <Title title='my' subTitle='projects' />

     <Grid container spacing={5} justifyContent="center">
        {project.map((singleProject) => (
          <Grid item key={singleProject.id} xs={12} sm={6} md={4}>
            <a href={singleProject.href} target='blank'>
            <Card className={`${styles.cardSection} ${styles.animationClass}`} data-aos="zoom-in" sx={{ maxWidth: 345, bgcolor:'gray', m:'auto', borderRadius:4 }}>
            <CardMedia
                component="img"
                alt={singleProject.title}
                height="140"
                image={singleProject.image}
                icon= {singleProject.icon}
                
              />
              <CardContent className={styles.cardContent}>
                <Typography gutterBottom variant="h5" component="div" textAlign='center'>
                  {singleProject.title}
                </Typography>
                <Typography variant="body2" color="text.primary">
                  {singleProject.info}
                </Typography>
              </CardContent>
              <CardActions className={styles.cardActions}>
              {singleProject.icon1}
              {singleProject.icon2}
              {singleProject.icon3}
              {singleProject.icon4}
              </CardActions>
            </Card>
            </a>
           
          </Grid>
        ))}
      </Grid>

      <div className={styles.projectSection}>
      <h5>TO SEE MY OTHER PROJECTS <br /> PLEASE VISIT MY GITHUB PROFILE.</h5>
      <a href="https://github.com/mrTuranWebDeveloper" className={styles.btn} target='blank'>My Github Profile</a>
      </div>

    </section>
  );
}
